import './scss/pages/archive-programs.scss';
import { searchFilters } from './js/components/search-filters.js';

window.addEventListener( 'DOMContentLoaded', () => {

	searchFilters();

} );
